import React from 'react'
import store from './state/store'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { IndexRoute, Router, Route, browserHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'

import Base from './containers/Base'
import Manager from './containers/Manager'
import Login from './components/Login'
import AppsContainer from './containers/AppsContainer'
import Apps from './components/Apps'
import AppAdd from './components/AppAdd'
import AppEdit from './components/AppEdit'
import Dashboard from './components/Dashboard'
import UsersContainer from './containers/UsersContainer'
import Users from './components/Users'
import UserEdit from './components/UserEdit'
import UserAdd from './components/UserAdd'
import UserDetail from './components/UserDetail'
import TransactionsContainer from './containers/TransactionsContainer'
import Transactions from './components/Transactions'
import TransactionDetail from './components/TransactionDetail'
import EntityContainer from './containers/EntityContainer'
import Entity from './components/Entity'
import EntityDetail from './components/EntityDetail'
import SubscriptionContainer from './containers/SubscriptionContainer'
import Subscriptions from './components/Subscriptions'
import SubscriptionsDetail from './components/SubscriptionsDetail'

/*if (process.env.project.SENTRY_DSN) {
    window.Raven.config(process.env.project.SENTRY_DSN, {release: process.env.project.RELEASE_VERSION}).install()
    window.onunhandledrejection = e => {
        console.warn('Unhandled Promise Rejection', e.reason) // eslint-disable-line no-console
        window.Raven.captureException(e.reason, {
            extra: {
                unhandledPromise: true
            }
        })
    }
}*/

const rootElement = document.getElementById('root')
const history = syncHistoryWithStore(browserHistory, store)

render(
    <Provider store={store}>
        <Router history={history} onUpdate={() => window.scrollTo(0, 0)}>
            <Route path="/manager" component={Base}>
                <Route path="login" component={Login}/>
                <Route path="app" component={AppsContainer}>
                    <IndexRoute component={Apps}/>
                    <Route path="add" component={AppAdd}/>
                    <Route path="edit/:appId" component={AppEdit}/>
                </Route>
                <Route path=":appCodename" component={Manager}>
                    <Route path="dashboard" component={Dashboard}/>
                    <Route path="user" component={UsersContainer}>
                        <IndexRoute component={Users}/>
                        <Route path="add" component={UserAdd}/>
                        <Route path="edit/:userId" component={UserEdit}/>
                        <Route path=":userId" component={UserDetail}/>
                    </Route>
                    <Route path="transactions" component={TransactionsContainer}>
                        <IndexRoute component={Transactions}/>
                        <Route path="detail/:transactionId" component={ TransactionDetail }/>
                    </Route>
                    <Route path="entity" component={EntityContainer}>
                        <IndexRoute component={Entity}/>
                        <Route path="detail/:entityId" component={ EntityDetail }/>
                        <Route path=":entityId/transactions" component={ Transactions }/>
                        <Route path=":entityId/transactions/detail/:transactionId" component={ TransactionDetail }/>
                    </Route>
                    <Route path="subscriptions" component={SubscriptionContainer}>
                        <IndexRoute component={Subscriptions}/>
                        <Route path="detail/:subscriptionId" component={ SubscriptionsDetail }/>
                        <Route path=":subscriptionId/transactions" component={ Transactions }/>
                        <Route path=":subscriptionId/transactions/detail/:transactionId" component={ TransactionDetail }/>
                    </Route>
                </Route>
            </Route>
        </Router>
    </Provider>, rootElement)



// WEBPACK FOOTER //
// ./index.js